import { SubscriptionStatus } from '../server/mpsklad_core/Entity/Enums/SubscriptionStatus'

export const subscriptionStatusNames: {
  readonly [K in SubscriptionStatus]: string
} = {
  [SubscriptionStatus.NotSubscribed]: 'Не оплачена',
  [SubscriptionStatus.Active]: 'Активна',
  [SubscriptionStatus.Expired]: 'Истекла'
}